import { z } from "zod";

import type { RedlineAuthorSide } from "@common/utils/redlineAuthorColors";

const RedlineAuthorSidesEventSchema = z.object({
  type: z.literal("redline_author_sides"),
  authors: z.array(z.object({ author: z.string(), side: z.enum(["our_side", "counterparty"]) })),
});

export function redlineAuthorSidesOf(toolResultContent: unknown): RedlineAuthorSide[] | null {
  if (typeof toolResultContent !== "string" || !toolResultContent.includes("redline_author_sides")) return null;
  let payload: unknown;
  try {
    payload = JSON.parse(toolResultContent);
  } catch {
    return null;
  }
  const event = RedlineAuthorSidesEventSchema.safeParse(payload);
  return event.success ? event.data.authors.map(({ author, side }) => ({ name: author, side })) : null;
}
